import { useLocation } from "react-router-dom";
import TableOfContentsItem from "./TableOfContentsItem";
import { DrugCategoriesIndex } from "../DrugCategoriesIndex";
import { useDrugCategoriesIndex } from "../../hooks/drugCategoriesHooks/useDrugCategoriesIndex";

function TableOfContentsList({ items }) {
  const location = useLocation();
  const drugCategoriesData = useDrugCategoriesIndex();

  if (!items || items.length === 0) return null;

  // Check if we're on the pregnancy/breastfeeding page
  const isPregnancyBreastfeedingPage = () => {
    const searchParams = new URLSearchParams(location.search);
    const guidelinePage = searchParams.get("guidelinePage");
    return guidelinePage === "quicklinks" || location.pathname.includes("quicklinks");
  };

  // Check if this TOC list contains drug categories
  const hasDrugCategories = () => {
    return items.some(
      (item) =>
        item.title &&
        item.title.includes("Drugs and their categories in pregnancy and breastfeeding:"),
    );
  };

  const shouldShowDrugIndex = isPregnancyBreastfeedingPage() && hasDrugCategories();

  const handleDrugCategoryClick = (category) => {
    if (drugCategoriesData.navigateToCategory) {
      drugCategoriesData.navigateToCategory(category);
    }
  };

  const getItemId = (item) => {
    return (
      item?.id ??
      item?.href ??
      new URLSearchParams(item?.msPath?.split("?")[1] || "").get("sectionId")
    );
  };

  // If we should show the drug index, render it instead of the standard list
  if (shouldShowDrugIndex) {
    return (
      <DrugCategoriesIndex
        categories={drugCategoriesData.categories}
        onCategoryClick={handleDrugCategoryClick}
        activeCategory={drugCategoriesData.activeCategory}
      />
    );
  }

  return (
    <ul>
      {items.map((item) => (
        <TableOfContentsItem key={getItemId(item)} item={item} />
      ))}
    </ul>
  );
}

export default TableOfContentsList;
